import { Trans, useTranslation } from "react-i18next";
import CodeBlock from "../components/CodeBlock";

export default function AchievementCard() {
  const { t } = useTranslation();

  return (
    <article>
      <h1>{t("achievementCard.title")}</h1>
      <p>{t("achievementCard.intro")}</p>

      <CodeBlock title="achievementImage()">{`import { achievementImage } from "kira-arts";

const buffer = await achievementImage(userId, "First win", {
  guildId,
  useRoleColor: true,
  description: "You won your first ranked match.",
  rarity: "epic",
});`}</CodeBlock>

      <h2>{t("achievementCard.optionsTitle")}</h2>
      <CodeBlock title="AchievementOptions">{`description?: string;
iconUrl?: string;
rarity?: "common" | "rare" | "epic" | "legendary";
accentColor?: string;
borderColor?: ColorInput;
removeBorder?: boolean;
useNitroTheme?: boolean;
useRoleColor?: boolean;
customBackground?: string;
progressText?: string;
showUsername?: boolean;
guildId?: string;
theme?: KiraThemeName;`}</CodeBlock>

      <p>
        <Trans
          i18nKey="achievementCard.note"
          components={[<code key="0" />, <code key="1" />, <code key="2" />]}
        />
      </p>

      <p>
        <Trans
          i18nKey="achievementCard.progressNote"
          components={[<code key="0" />, <code key="1" />]}
        />
      </p>
    </article>
  );
}
